<a class="cookie-policy" rel="noopener" [href]="resourcesURL" target="_blank"
   _ti_full_access_panel_cookie_policy="cookie_policy_anchor">
    Cookie Policy
</a>